// import ReleasePage from './views/ReleasePage';

export const releaseRoutes = [
  // {
  //   path: '/release/:organizationId',
  //   component: ReleasePage,
  //   name: 'ReleasePage'
  // }
]